import React from 'react';
import styles from './WarehouseStatCard.module.css';

type IconType = 'ordersPick' | 'ordersPacked' | 'lowStock' | 'damaged' | 'returns';
type ColorType = 'blue' | 'green' | 'orange' | 'red' | 'purple';

interface WarehouseStatCardProps {
  title: string;
  value: string;
  icon: IconType;
  color: ColorType;
}

const icons: Record<IconType, React.ReactNode> = {
  ordersPick: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2zm0-4H7V7h10v2z" />
    </svg>
  ),
  ordersPacked: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v3h2V4h16v16H4v-3H2v3c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 16l4-4h-3V9h-2v5H8l4 4zm-7-7h10v2H5v-2z" />
    </svg>
  ),
  lowStock: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  ),
  damaged: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  ),
  returns: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" />
    </svg>
  ),
};

export const WarehouseStatCard: React.FC<WarehouseStatCardProps> = ({ title, value, icon, color }) => {
  return (
    <div className={styles.card}>
      <div className={`${styles.iconWrapper} ${styles[color]}`}>
        {icons[icon]}
      </div>
      <p className={styles.title}>{title}</p>
      <p className={`${styles.value} ${styles[`value_${color}`]}`}>{value}</p>
    </div>
  );
};
